import { render, staticRenderFns } from "./qiangzhi.vue?vue&type=template&id=f8688700&scoped=true"
import script from "./qiangzhi.vue?vue&type=script&lang=js"
export * from "./qiangzhi.vue?vue&type=script&lang=js"
import style0 from "./qiangzhi.vue?vue&type=style&index=0&id=f8688700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8688700",
  null
  
)

export default component.exports